import { selectFeatureFlags, selectUserContext } from 'core/userContext';
import { JOURNEY_EVENTS_METRICS } from 'modules/billing/constants';
import { useProjectQueryContext } from 'modules/billing/contexts/ProjectQueryContext';
import { OrgProjectJourneyMetric } from 'modules/domains/billing';
import { useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router';
import { createBreadcrumb, createProjectBreakdownColumns, queryByFn } from '../../utils';
import { SimpleIndexPage } from '../SimpleIndexPage/SimpleIndexPage';
import { Row } from '../SimpleIndexPage/types';
import { ProjectUsagePageActions } from './ProjectUsagePageActions';
import { createRowCell } from './TableCell';

const createProjectJourneyRows = ({
  authenticatedProjectId,
  projectJourneys,
  projectId,
}: {
  authenticatedProjectId?: number;
  projectId: number;
  projectJourneys: OrgProjectJourneyMetric[];
}) => {
  if (!projectJourneys || !projectId) {
    return [];
  }

  const journeyRows: Row[] = projectJourneys
    .sort((a, b) => a.value - b.value)
    .map((journey) => ({
      href:
        authenticatedProjectId && authenticatedProjectId === projectId
          ? `/workflows/${journey.journeyId}/edit?mode=beta&workflowType=Published`
          : undefined,
      id: journey.journeyId,
      projectId: journey.journeyId,
      projectName: `Journey ID: ${journey.journeyId}`,
      pinned: false,
      JvtCount: journey.value,
    }));

  return journeyRows;
};

export const JourneyEventsProjectUsageByProject = () => {
  const { JourneyExitEvents } = useSelector(selectFeatureFlags);
  const context = useSelector(selectUserContext);
  const { projectId = 0 } = useParams<{ projectId?: string }>();
  const { search } = useLocation();
  const {
    isLoading,
    projects,
    projectUsageMetrics: { ByOrgProjectJourney = {} },
  } = useProjectQueryContext();

  const metricNames = [JOURNEY_EVENTS_METRICS.jvtCount];
  const breadcrumb = createBreadcrumb(search);
  const columns = createProjectBreakdownColumns(metricNames);

  const currentProject = projects[projectId || 0];

  const projectJourneys = ByOrgProjectJourney[projectId || 0] || [];
  const journeyRows = createProjectJourneyRows({
    authenticatedProjectId: context?.project?.id,
    projectJourneys,
    projectId: Number(projectId),
  });

  return (
    <>
      {JourneyExitEvents && (
        <SimpleIndexPage
          breadcrumb={breadcrumb}
          projectsBreadcrumb={{
            content: 'All projects',
            href: `/payments/info/journeyEventsUsage${search}`,
          }}
          columns={columns}
          createRowCell={createRowCell}
          isLoading={isLoading}
          pageActions={<ProjectUsagePageActions />}
          pageTitle={`Journey events: ${isLoading ? '' : currentProject?.name}`}
          queryByFn={queryByFn}
          rows={journeyRows}
        />
      )}
    </>
  );
};
